<!-- 入库单据数字化维护 -->
<template>
  <div class="nx-list-page">
    <avue-crud ref="crud" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" @search-change="searchChange" @search-reset="searchReset" @row-del="rowDel" @current-change="currentChange"
      @size-change="sizeChange" @on-load="onLoad" @refresh-change="refreshChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <!-- <template slot-scope="scope" slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </template> -->
      <template slot-scope="{row, index}" slot="menu">
        <el-button type="text" size="mini" @click="getInfo(row)">详情</el-button>
        <el-button type="text" size="mini" @click="handleUpdate(row)">修改</el-button>
        <el-button type="text" size="mini" @click="$refs.crud.rowDel(row, index)">删除</el-button>
      </template>
    </avue-crud>
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, remove, exportExcel } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
import { downloadXls } from '@/util/util'

export default {
  mixins: [crudMixins],
  data () {
    return {
      apiConfig: { getList, remove },
      exportLoading: false,
      defaultParams: {
        businessType: 1,
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: false,
        menu: false,
        column: [
          {
            label: '煤种',
            prop: 'cargoNo',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'varName',
              value: 'varNo'
            },
          },
          {
            label: '仓库',
            prop: 'stockName',
            overHidden: true, // 表格超出隐藏
            width: 150,
          },
          {
            label: '库区',
            prop: 'locationName',
            overHidden: true, // 表格超出隐藏
            width: 150,
          },
          {
            label: '合同名称',
            prop: 'contractName',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/transport-contract/select/distinct/pycode?contractName={{key}}',
            props: {
              label: 'contractName',
              value: 'id'
            },
          },
          {
            label: '入库时间',
            prop: 'createTime',
            overHidden: true, // 表格超出隐藏
            width: 150,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: '入库量',
            prop: 'weight',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'number',
            precision: 0,
            min: 1,
            max: 99999,
          },
          {
            label: '客户',
            prop: 'custNo',
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            search: true, // 查询是否显示
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: '车次',
            prop: 'trainNumber',
            search: true, // 查询是否显示
            maxlength: 30,
          },
          {
            label: '操作人',
            prop: 'updateName',
            width: 150,
            overHidden: true, // 表格超出隐藏
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  },
  created () {
    console.log(this)
  },
  methods: {
    //打开新增弹窗
    handleAdd () {
      this.$router.push({
        path: '/railway-management/outInStockRecord/info',
        query: { title: '新增入库信息' }
      })
    },
    async handleExport () {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `入库单据_${Date.now()}.xlsx`)
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`)
        } else {
          this.$message.success('导出成功')
        }
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    // 打开修改弹窗
    handleUpdate (row) {
      this.$router.push({
        path: '/railway-management/outInStockRecord/info',
        query: { id: row.id, title: '修改入库信息' }
      })
    },
    // 打开详情弹窗
    getInfo (row) {
      this.$router.push({
        path: '/railway-management/outInStockRecord/info',
        query: { id: row.id, title: '入库信息详情' }
      })
    },
  }
}
</script>

<style scoped lang="scss"></style>
